import React from 'react';

import Tooltip from '../../Tooltip';

const TooltipRendererWrapper = ({
  showTooltip,
  title,
  children,
}: {
  showTooltip: boolean;
  title: string | React.ReactNode;
  children: React.ReactNode;
}) => {
  if (showTooltip)
    return (
      <Tooltip title={title} placement="right" variant="light" innerClassName="!v2-ml-2">
        {React.isValidElement(children) ? children : <>{children}</>}
      </Tooltip>
    );
  return children;
};

export default TooltipRendererWrapper;
